import React from 'react'
import './SliderComponent.scss'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import Slider from 'react-slick'

import { Modal } from 'react-bootstrap'
import { isMobile } from 'react-device-detect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons'

function SampleNextArrow(props) {
  const { onClick } = props
  return (
    <button className="slider__arrow slider__arrow--right" onClick={onClick}>
      <FontAwesomeIcon icon={faChevronRight} className="slider__arrow__icon" />
    </button>
  )
}

function SamplePrevArrow(props) {
  const { onClick } = props
  return (
    <button className="slider__arrow slider__arrow--left" onClick={onClick}>
      <FontAwesomeIcon icon={faChevronLeft} className="slider__arrow__icon" />
    </button>
  )
}

const SliderComponent = (props) => {
  let settings = {
    adaptiveHeight: true,
    infinite: true,
    accessibility: true,
    lazyLoad: 'ondemand',
    fade: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  }
  const { images, id, onClose, isOpen } = props

  let newArray = []
  images.forEach((item) => {
    if (item.id >= id) {
      newArray.push(item)
    }
  })
  images.forEach((item) => {
    if (item.id < id) {
      newArray.push(item)
    }
  })

  return (
    <Modal
      show={isOpen}
      onHide={() => onClose(false)}
      dialogClassName="modal-90w sliderModal"
      contentClassName="sliderModal__content"
      backdropClassName="sliderModal__backdrop"
      centered
      aria-labelledby="Kominiarze-galeria-modal"
    >
      <Modal.Header bsPrefix="Yolo">
        <button className="sliderModal__button" onClick={() => onClose(false)}>
          <FontAwesomeIcon icon={faTimes} className="sliderModal__button__icon" />
        </button>
      </Modal.Header>
      <Modal.Body className="sliderModal__content">
        <Slider {...settings} className="slider">
          {newArray &&
            newArray.length &&
            newArray.map((item) => (
              <div className="slider__imageBox" key={item.name + item.id}>
                <img src={isMobile ? item.thumbUrl : item.url} className="slider__image" alt={item.name + item.id} />
              </div>
            ))}
        </Slider>
      </Modal.Body>
    </Modal>
  )
}

export default SliderComponent
